import React from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "styled-components";
import { Container, Box, Typography, Grid } from "@mui/material";
import ImageViewer from "../molecules/ContributionView/ImageViewer";
import VideoPlayer from "../molecules/ContributionView/VideoPlayer";

const HoldingDetailPage = () => {
  const location = useLocation();
  const { holding } = location.state || {};
  const theme = useTheme();

  console.log("HoldingDetailPage holding: ", holding);

  // Helper to format the date in a human-readable format
  const formatDate = (dateString) => {
    if (!dateString) return "Unknown Date";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formattedContributionTotal = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(holding?.purchasePricePerArtwork || 0);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Full-width row for Video/Image */}
      <Box sx={{ marginBottom: 4 }}>
        {holding.expectedMediaType.startsWith("Video") ? (
          <VideoPlayer holding={holding} />
        ) : holding.expectedMediaType.startsWith("Image") ? (
          <ImageViewer holding={holding} />
        ) : (
          <Typography
            variant="caption"
            sx={{
              display: "block",
              textAlign: "center",
              marginTop: "10px",
              fontSize: "0.9em",
              fontFamily: "basic-sans",
            }}
          >
            Unsupported content type: {holding.expectedMediaType}
          </Typography>
        )}
      </Box>

      {/* Row for Title, Description, and Contribution Data */}
      <Grid container spacing={4}>
        {/* Left Column: Title and Description */}
        <Grid item xs={12} md={8}>
          {/* Title */}
          {holding.title && (
            <Typography
              variant="h5"
              sx={{
                marginBottom: 2,
                fontWeight: "bold",
                fontFamily: "basic-sans",
                wordBreak: "break-word",
              }}
            >
              {holding.title}
            </Typography>
          )}
          {/* Description */}
          {holding.artDescription && (
            <Typography
              variant="body1"
              sx={{
                color: theme.colors.gray,
                fontFamily: "basic-sans",
                wordBreak: "break-word",
              }}
            >
              {holding.artDescription}
            </Typography>
          )}
        </Grid>

        {/* Right Column: Contribution Data */}
        <Grid item xs={12} md={4}>
          <Box>
            {/* Uploader and Year */}
            <Typography
              variant="body2"
              sx={{
                marginBottom: 1,
                fontWeight: "bold",
                fontFamily: "basic-sans",
              }}
            >
              Submission by: {holding.uploaderUserName || "Unknown"} |{" "}
              {holding.artYear || "Unknown"}
            </Typography>

            {/* Contribution Total */}
            <Typography
              variant="body2"
              sx={{
                marginBottom: 1,
                fontFamily: "basic-sans",
              }}
            >
              Transaction total: $
              {formattedContributionTotal}
            </Typography>

            {/* Latest Purchase Date */}
            <Typography
              variant="body2"
              sx={{
                marginBottom: 1,
                fontFamily: "basic-sans",
              }}
            >
              Transaction date: {formatDate(holding.latestPurchaseDate)}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default HoldingDetailPage;
